/* Velvet · Complete o look (sections/velvet-complete-o-look.liquid) */
(function () {
  if (customElements.get('velvet-complete-o-look')) return;

  function formatarDinheiro(centavos, formato) {
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var milhar = function (n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      switch (tipo) {
        case 'amount_no_decimals': return milhar(partes[0], ',');
        case 'amount_with_comma_separator': return milhar(partes[0], '.') + ',' + partes[1];
        case 'amount_no_decimals_with_comma_separator': return milhar(partes[0], '.');
        default: return milhar(partes[0], ',') + '.' + partes[1];
      }
    });
  }

  function adicionarNaSacola(itens) {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: itens })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || r.status); });
      return r.json();
    });
  }

  /* Atualiza a sacola lateral do Palo Alto (contador, itens e frete grátis) sem abrir:
     a cliente continua no produto principal (decisão 7 do 02-08). O build() do tema sempre
     chama openCartDrawer() logo depois de disparar 'theme:cart:added'; aqui ele vira um
     no-op só nessa atualização e volta ao normal em seguida. Sem sacola lateral, nada a fazer. */
  function atualizarSacolaSemAbrir() {
    var sacola = window.cart;
    if (!sacola || typeof sacola.getCart !== 'function') return;
    if (typeof sacola.openCartDrawer === 'function') {
      var tinhaPropria = Object.prototype.hasOwnProperty.call(sacola, 'openCartDrawer');
      var original = sacola.openCartDrawer;
      var devolvido = false;
      var devolver = function () {
        if (devolvido) return;
        devolvido = true;
        document.removeEventListener('theme:cart:added', aoAdicionar);
        if (tinhaPropria) sacola.openCartDrawer = original;
        else delete sacola.openCartDrawer;
      };
      var aoAdicionar = function () { setTimeout(devolver, 0); };
      sacola.openCartDrawer = function () {};
      document.addEventListener('theme:cart:added', aoAdicionar);
      setTimeout(devolver, 8000);
    }
    sacola.getCart();
  }

  /* Seletor de variante próprio (feedback 14/10, item 8): a lista aberta do <select> é desenhada
     pelo sistema e não aceita estilo. O <select> continua no DOM, escondido, e segue sendo a fonte
     do valor: escolher uma opção aqui muda o select e dispara o 'change' de sempre. */
  var seletorAberto = null;

  function fecharSeletor(foco) {
    if (!seletorAberto) return;
    var s = seletorAberto;
    seletorAberto = null;
    s.botao.setAttribute('aria-expanded', 'false');
    s.lista.hidden = true;
    s.raiz.classList.remove('velvet-select--aberto', 'velvet-select--cima');
    if (foco) s.botao.focus();
  }

  document.addEventListener('click', function (e) {
    if (seletorAberto && !seletorAberto.raiz.contains(e.target)) fecharSeletor(false);
  });

  function montarSeletor(select, textos) {
    var id = 'velvet-select-' + Math.random().toString(36).slice(2, 8);
    var raiz = document.createElement('div');
    raiz.className = 'velvet-select';
    var botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'velvet-select__botao';
    botao.setAttribute('aria-haspopup', 'listbox');
    botao.setAttribute('aria-expanded', 'false');
    botao.setAttribute('aria-controls', id);
    if (select.getAttribute('aria-label')) botao.setAttribute('aria-label', select.getAttribute('aria-label'));
    var rotulo = document.createElement('span');
    rotulo.className = 'velvet-select__rotulo';
    botao.appendChild(rotulo);
    var lista = document.createElement('ul');
    lista.className = 'velvet-select__lista';
    lista.id = id;
    lista.setAttribute('role', 'listbox');
    lista.tabIndex = -1;
    lista.hidden = true;

    var opcoes = Array.from(select.options).map(function (opcao) {
      var li = document.createElement('li');
      li.className = 'velvet-select__opcao';
      li.setAttribute('role', 'option');
      li.dataset.valor = opcao.value;
      li.id = id + '-' + opcao.index;
      li.textContent = opcao.textContent.trim();
      if (opcao.disabled) {
        li.setAttribute('aria-disabled', 'true');
        var extra = document.createElement('span');
        extra.className = 'velvet-select__esgotado';
        extra.textContent = textos.esgotado || '';
        li.appendChild(extra);
      }
      lista.appendChild(li);
      return li;
    });

    function sincronizar() {
      rotulo.textContent = select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : '';
      opcoes.forEach(function (li) { li.setAttribute('aria-selected', li.dataset.valor === select.value ? 'true' : 'false'); });
    }

    function ativa() { return lista.querySelector('.is-ativa'); }
    function marcar(li) {
      opcoes.forEach(function (o) { o.classList.toggle('is-ativa', o === li); });
      if (li) { lista.setAttribute('aria-activedescendant', li.id); li.scrollIntoView({ block: 'nearest' }); }
    }
    function mover(passo) {
      var livres = opcoes.filter(function (o) { return o.getAttribute('aria-disabled') !== 'true'; });
      var i = livres.indexOf(ativa());
      marcar(livres[Math.min(livres.length - 1, Math.max(0, i + passo))]);
    }

    function abrir() {
      if (seletorAberto) fecharSeletor(false);
      seletorAberto = { raiz: raiz, botao: botao, lista: lista };
      lista.hidden = false;
      raiz.classList.add('velvet-select--aberto');
      var r = botao.getBoundingClientRect();
      if (window.innerHeight - r.bottom < lista.offsetHeight + 16 && r.top > lista.offsetHeight + 16) raiz.classList.add('velvet-select--cima');
      botao.setAttribute('aria-expanded', 'true');
      marcar(opcoes.find(function (o) { return o.dataset.valor === select.value; }));
      lista.focus({ preventScroll: true });
    }

    function escolher(li) {
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      if (select.value !== li.dataset.valor) {
        select.value = li.dataset.valor;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sincronizar();
      fecharSeletor(true);
    }

    botao.addEventListener('click', function () { seletorAberto && seletorAberto.raiz === raiz ? fecharSeletor(true) : abrir(); });
    botao.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); abrir(); }
    });
    lista.addEventListener('click', function (e) { escolher(e.target.closest('.velvet-select__opcao')); });
    lista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); mover(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mover(-1); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); escolher(ativa()); }
      else if (e.key === 'Escape') { e.preventDefault(); fecharSeletor(true); }
      else if (e.key === 'Tab') { fecharSeletor(false); }
    });

    select.classList.add('velvet-select__nativo');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    select.parentNode.insertBefore(raiz, select);
    raiz.appendChild(botao);
    raiz.appendChild(lista);
    raiz.appendChild(select);
    sincronizar();
  }

  class VelvetCompleteOLook extends HTMLElement {
    connectedCallback() {
      if (this.iniciado) return;
      this.iniciado = true;
      this.formato = this.dataset.moneyFormat || 'R$ {{amount_with_comma_separator}}';
      try {
        this.textos = JSON.parse(this.querySelector('[data-look-textos]').textContent);
      } catch (e) {
        this.textos = {};
      }
      this.botaoTodos = this.querySelector('[data-look-todos]');
      this.erro = this.querySelector('[data-look-erro]');

      this.querySelectorAll('select[data-look-variante]').forEach((select) => montarSeletor(select, this.textos));

      this.addEventListener('change', (e) => {
        if (e.target.matches('select[data-look-variante]')) this.trocarVariante(e.target);
      });
      this.addEventListener('click', (e) => {
        var um = e.target.closest('[data-look-adicionar]');
        if (um) this.adicionar([um.closest('[data-look-item]')], um);
        if (e.target.closest('[data-look-todos]')) this.adicionar(this.itensDisponiveis(), this.botaoTodos);
      });

      this.atualizarResumo();
    }

    itensDisponiveis() {
      return Array.from(this.querySelectorAll('[data-look-item]')).filter(function (item) {
        return item.querySelector('[data-look-variante]');
      });
    }

    precoDoItem(item) {
      var campo = item.querySelector('[data-look-variante]');
      if (campo.tagName === 'SELECT') return parseInt(campo.selectedOptions[0].dataset.preco, 10) || 0;
      return parseInt(item.querySelector('[data-look-adicionar]').dataset.preco, 10) || 0;
    }

    trocarVariante(select) {
      var item = select.closest('[data-look-item]');
      var opcao = select.selectedOptions[0];
      item.querySelector('[data-look-preco]').textContent = formatarDinheiro(parseInt(opcao.dataset.preco, 10), this.formato);
      var nome = item.querySelector('[data-look-variante-nome]');
      if (nome) nome.textContent = opcao.textContent.trim();
      this.atualizarResumo();
    }

    atualizarResumo() {
      var itens = this.itensDisponiveis();
      var n = itens.length;
      var total = itens.reduce((soma, item) => soma + this.precoDoItem(item), 0);
      this.querySelector('[data-look-quantidade]').textContent =
        n === 1 ? this.textos.um : String(this.textos.varios || '').replace('[n]', n);
      this.querySelector('[data-look-total]').textContent = formatarDinheiro(total, this.formato);
      this.querySelector('[data-look-todos-texto]').textContent =
        n === 1 ? this.textos.um_botao : String(this.textos.todos || '').replace('[n]', n);
      this.botaoTodos.hidden = n === 0;
    }

    adicionar(itens, botao) {
      if (!itens.length || botao.disabled) return;
      var payload = itens.map(function (item) {
        return { id: parseInt(item.querySelector('[data-look-variante]').value, 10), quantity: 1 };
      });
      botao.disabled = true;
      botao.classList.add('is-loading');
      this.erro.hidden = true;
      adicionarNaSacola(payload)
        .then(() => {
          atualizarSacolaSemAbrir();
          this.mostrarAdicionado(botao);
        })
        .catch((e) => {
          this.erro.textContent = this.textos.erro || e.message;
          this.erro.hidden = false;
        })
        .finally(function () {
          botao.disabled = false;
          botao.classList.remove('is-loading');
        });
    }

    /* o botão vira "Adicionado" por 2,5 s e volta ao texto de antes */
    mostrarAdicionado(botao) {
      var alvo = botao.querySelector('[data-look-todos-texto]') || botao;
      if (!botao.velvetTextoOriginal) botao.velvetTextoOriginal = alvo.textContent;
      alvo.setAttribute('aria-live', 'polite');
      alvo.textContent = this.textos.adicionado || botao.velvetTextoOriginal;
      botao.classList.add('is-added');
      clearTimeout(botao.velvetTimer);
      botao.velvetTimer = setTimeout(() => {
        alvo.textContent = botao.velvetTextoOriginal;
        botao.velvetTextoOriginal = null;
        botao.classList.remove('is-added');
        this.atualizarResumo();
      }, 2500);
    }
  }

  customElements.define('velvet-complete-o-look', VelvetCompleteOLook);
})();
